// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"0c01c418","98":"0b43bd96","147":"b739adf4","171":"5a41529b","374":"63701aa6","429":"0ef759c0","507":"b0f23934","528":"4e316461","546":"68a8a35a","780":"8b6542ab"}[chunkId] + ".chunk.js";
};